import { JSX } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function XLSXIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon width="12" height="14" viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg" {...props} fill={props.fill}>
      <path
        d="M7.33332 0.333374H1.99999C1.64637 0.333374 1.30723 0.47385 1.05718 0.723898C0.807132 0.973947 0.666656 1.31309 0.666656 1.66671V12.3334C0.666656 13.0734 1.25999 13.6667 1.99999 13.6667H9.99999C10.74 13.6667 11.3333 13.0734 11.3333 12.3334V4.33337L7.33332 0.333374ZM9.99999 12.3334H1.99999V1.66671H6.66666V5.00004H9.99999V12.3334ZM6.59999 8.66671L8.53332 11.6667H7.33332L5.99999 9.40004L4.66666 11.6667H3.46666L5.39999 8.66671L3.46666 5.66671H4.66666L5.99999 7.93337L7.33332 5.66671H8.53332L6.59999 8.66671Z"
        fill={props.fill}
      />
    </SvgIcon>
  );
}
